import React from 'react';
import { useTracks, ParticipantTile } from '@livekit/components-react';
import { Track } from 'livekit-client';

const MAX_TILES = 5;

const VideoTiles = ({ style, tileStyle }) => {
  const tracks = useTracks(
    [{ source: Track.Source.Camera, withPlaceholder: true }],
    { onlySubscribed: false }
  ).slice(0, MAX_TILES);

  return (
    <div style={{ display: 'flex', gap: 8, ...style }}>
      {tracks.map((trackRef) => (
        <div
          key={`${trackRef.participant.identity}-${trackRef.publication?.trackSid || 'cam'}`}
          style={{
            width: 120,
            height: 90,
            border: 'var(--border-ink-sm)',
            borderRadius: 8,
            overflow: 'hidden',
            background: '#000',
            boxShadow: 'var(--shadow-hard-sm)',
            ...tileStyle,
          }}
        >
          <ParticipantTile trackRef={trackRef} disableSpeakingIndicator />
        </div>
      ))}
    </div>
  );
};

export default VideoTiles;
